export default __webpack_public_path__ + "static/sound-5fa0e9e0df5f0a2c36efac88db738c68.mp3";